let initialized = false;
let measurementIdCached: string | null = null;

const getDataLayer = () => {
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  return window.dataLayer;
};

const injectGtag = (id: string) => {
  if (document.querySelector(`script[src*="${id}"]`)) {
    return;
  }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  } as unknown as typeof window.gtag;

  window.gtag('js', new Date());
  window.gtag('config', id, { send_page_view: false });
};

export const initGA = (measurementId?: string) => {
  const id = measurementId;
  if (!id) {
    console.warn('GA4 measurement ID is not configured. Set GA_MEASUREMENT_ID in the backend .env');
    return;
  }

  if (initialized && measurementIdCached === id) {
    return;
  }

  measurementIdCached = id;
  injectGtag(id);
  initialized = true;
};

export const trackPageView = (path: string) => {
  if (!initialized) {
    return;
  }

  getDataLayer().push({
    event: 'page_view',
    page_path: path,
    page_location: `${window.location.origin}${path}`,
    page_title: document.title,
  });
};

export const trackEvent = (name: string, params: Record<string, unknown> = {}) => {
  if (!initialized) {
    return;
  }

  getDataLayer().push({
    event: name,
    ...params,
  });
};
